import React from 'react';
import { Dialog, DialogContent, Box, Typography, Button } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';
import { useAuthStore } from '../stores/auth.store';
import styled from 'styled-components';

const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    background: #1e1e2e;
    border-radius: 20px;
    border: 2px solid #292929;
    max-width: 500px;
    width: 90%;
    margin: 16px;
    overflow: visible;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.5);
  }

  .MuiBackdrop-root {
    background: rgba(0, 0, 0, 0.85);
    backdrop-filter: blur(8px);
  }
`;

export const CalendarFlowLogoutConfirmation: React.FC = () => {
  const { logout } = useAuth0();
  const showLogoutConfirmation = useAuthStore(
    (state) => state.showLogoutConfirmation
  );
  const setShowLogoutConfirmation = useAuthStore(
    (state) => state.setShowLogoutConfirmation
  );

  const handleSignOut = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  const handleBackToKeysha = () => {
    setShowLogoutConfirmation(false);
  };

  return (
    <StyledDialog
      open={showLogoutConfirmation}
      onClose={handleBackToKeysha}
      maxWidth="sm"
      fullWidth
      aria-labelledby="logout-confirmation-title"
    >
      <DialogContent sx={{ p: 0 }}>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: { xs: '30px 20px', sm: '40px' },
          }}
        >
          {/* Keysha Logo */}
          <Box
            sx={{
              width: { xs: '80px', sm: '100px' },
              height: { xs: '80px', sm: '100px' },
              borderRadius: '50%',
              backgroundColor: '#6B46C1',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: { xs: '30px', sm: '40px' },
              fontSize: { xs: '32px', sm: '40px' },
              fontWeight: 'bold',
              color: '#FFFFFF',
              boxShadow: '0 4px 12px rgba(107, 70, 193, 0.4)',
            }}
          >
            K
          </Box>

          {/* Main Text */}
          <Typography
            id="logout-confirmation-title"
            sx={{
              fontSize: { xs: '20px', sm: '24px' },
              fontWeight: 600,
              color: '#FFFFFF',
              marginBottom: { xs: '35px', sm: '50px' },
              lineHeight: 1.3,
              textAlign: 'center',
              px: 2,
            }}
          >
            Are you sure you want to Sign Out?
          </Typography>

          {/* Buttons */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: '20px',
              width: '100%',
              maxWidth: '400px',
            }}
          >
            <Button
              onClick={handleSignOut}
              sx={{
                flex: 1,
                backgroundColor: '#E47676',
                color: 'black',
                borderRadius: '12px',
                padding: '16px 32px',
                fontSize: '16px',
                fontWeight: 600,
                textTransform: 'none',
                minWidth: { xs: '100%', sm: '140px' },
                '&:hover': {
                  backgroundColor: '#D65C5C',
                },
              }}
            >
              Sign Out
            </Button>
            <Button
              onClick={handleBackToKeysha}
              sx={{
                flex: 1,
                backgroundColor: '#6B46C1',
                color: '#FFFFFF',
                borderRadius: '12px',
                padding: '16px 32px',
                fontSize: '16px',
                fontWeight: 600,
                textTransform: 'none',
                minWidth: { xs: '100%', sm: '140px' },
                '&:hover': {
                  backgroundColor: '#553C9A',
                },
              }}
            >
              Back to Keysha
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </StyledDialog>
  );
};
